<div class="max-w-lg w-full p-6 bg-white rounded-lg shadow-lg">
  <h2 class="text-xl font-semibold">Confirmação</h2>
  <div class="mt-4">
    <p class="text-sm text-gray-600">Tem certeza que deseja inativar este usuário?</p>
  </div>
  <div class="mt-6 flex justify-end space-x-4">
    <button
      class="bg-gray-200 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-300 focus:outline-none"
      (click)="onCancel()"
      [attr.autofocus]="null"
    >
      Cancelar
    </button>
    <button
      class="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
      (click)="onConfirm()"
      autofocus
    >
      Inativar
    </button>
  </div>
</div>
